import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["trigger", "content"];

  show() {
    this.triggerTarget.hidden = true;
    this.contentTarget.hidden = false;
  }
}
